import React from 'react';
import { TRAFFIC_LIGHT } from '../engine/ceiling';
import { formatMoney } from '../format';

const STATUS_TEXT = {
  [TRAFFIC_LIGHT.GREEN]: 'Достижимо',
  [TRAFFIC_LIGHT.YELLOW]: 'На пределе',
  [TRAFFIC_LIGHT.RED]: 'Выше потолка',
};

const TrafficLight = ({ evaluation, ceilingRevenue }) => {
  if (!evaluation || !evaluation.valid) return null;

  return (
    <div className={`dg-traffic dg-traffic--${evaluation.status}`}>
      <div className="dg-traffic-head">
        <span className="dg-traffic-dot" aria-hidden="true" />
        <span className="dg-traffic-status">{STATUS_TEXT[evaluation.status]}</span>
      </div>

      <h3 className="dg-traffic-title">{evaluation.title}</h3>
      <p className="dg-traffic-text">{evaluation.text}</p>

      {evaluation.status === TRAFFIC_LIGHT.RED ? (
        <p className="dg-traffic-detail">
          Потолок при текущей модели — примерно {formatMoney(ceilingRevenue)} в месяц.
          Не хватает {formatMoney(evaluation.gap)}.
        </p>
      ) : null}
    </div>
  );
};

export default TrafficLight;
